import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../../apiSlice'
import { formDataCreate } from '../../../../utils/formDataUpload/formDataUpload'
import { IMessageAndStatusCode } from '../../admin/model'
import { ISearchParams } from '../../../../global.model'
import { IGetAllSections, IGetSectionById, TCreateSectionPayload } from './model'
import { TData } from '../../../../utils/formDataUpload/model'

export const expertSectionApis = createApi({
  reducerPath: 'expert-section/api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getAllSections: build.query<IGetAllSections, ISearchParams | void>({
      query: (params: ISearchParams) => ({ url: '/admin/course-section', params })
    }),
    getSectionById: build.query<IGetSectionById, number>({
      query: (sectionId: number) => `/admin/course-section/${sectionId}`
    }),
    createSection: build.mutation<IMessageAndStatusCode, TCreateSectionPayload>({
      query: sectionData => ({
        url: '/admin/course-section',
        method: 'POST',
        body: formDataCreate(sectionData as unknown as TData)
      })
    }),
    updateSection: build.mutation<IMessageAndStatusCode, TCreateSectionPayload>({
      query: sectionData => ({
        url: `/admin/course-section/${sectionData.id}`,
        method: 'PUT',
        body: formDataCreate(sectionData as unknown as TData)
      })
    }),
    deleteSectionById: build.mutation<{ message: string }, string>({
      query: (sectionId: string) => ({
        url: `/admin/course-section/${sectionId}`,
        method: 'DELETE'
      })
    })
  })
})
export const {
  useGetAllSectionsQuery,
  useGetSectionByIdQuery,
  useCreateSectionMutation,
  useUpdateSectionMutation,
  useDeleteSectionByIdMutation
} = expertSectionApis
